import Vue from "vue";
import VueRouter from "vue-router";
import vueXstore from "@/store/index";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
});

const whoami = async () => {
  try {
    const res = await Vue.axios.get("/whoami/");
    if (res.status === 200 || res.status === 201) {
      return { success: true, data: res.data };
    }
    console.warn("whoami failed with status:", res.status, res.data);
    return {
      success: false,
      error: `Status ${res.status}: Unable to fetch user data.`,
    };
  } catch (error) {
    console.error("whoami exception:", error);
    let errMsg = "Connection error";
    if (error.response) {
      console.error(
        "whoami error response:",
        error.response.status,
        error.response.data
      );
      errMsg = `Error ${error.response.status}: ${
        error.response.statusText || "Unknown error"
      }`;
    }
    return { success: false, error: errMsg };
  }
};

function getRole(RoleVal) {
  if (!Array.isArray(RoleVal)) {
    return false;
  }
  let checkRole = 0;
  for (let c = 0; c < RoleVal.length; c++) {
    const element = RoleVal[c];
    if (element && element.permission) {
      let valSp = element.permission.split(",");
      valSp.forEach((perm) => {
        if (["pc", "pd", "chair"].includes(perm.trim())) {
          checkRole++;
        }
      });
    }
  }
  return checkRole > 0;
}

import { msalInstance } from "@/plugins/msal";

router.beforeEach(async (to, from, next) => {
  // Always allow access to authentication page to prevent redirect loops
  if (to.name === "authen" || to.path === "/authen") {
    next();
    return;
  }

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    const isKeycloakAuth =
      router.app.$keycloak && router.app.$keycloak.authenticated;
    const isMsalAuth =
      localStorage.getItem("auth_type") === "msal" &&
      msalInstance.getAllAccounts().length > 0;

    if (isKeycloakAuth || isMsalAuth) {
      if (!vueXstore.state.role.RulesUser.username) {
        const res = await whoami();
        if (res.success) {
          const data = res.data;
          vueXstore.dispatch("setRoleUser", {
            username: data.username,
            role: data.roles,
            permissions: data.permissions,
            server_status: data.server_status,
            RolePdPCChair: getRole(data.roles),
          });
        } else {
          // whoami failed - clear session and redirect
          console.error("Auth check failed:", res.error);

          // Thoroughly clear all local storage
          localStorage.clear();

          // Clear Vuex state
          vueXstore.dispatch("setRoleUser", {
            username: "",
            role: [],
            permissions: "",
            server_status: "off",
            RolePdPCChair: false,
          });

          // Shorten error message for UI
          let simpleError = "Session expired";
          if (res.error && res.error.includes("401"))
            simpleError = "Unauthorized access";
          if (res.error && res.error.includes("Connection"))
            simpleError = "Network error";

          localStorage.setItem("login_error", simpleError);

          next({ name: "authen" });
          return;
        }
      }
      next();
    } else {
      next({ name: "authen" });
    }
  } else {
    next();
  }
});

export default router;

// export default new VueRouter({
//   mode: "history",
//   base: process.env.BASE_URL,
//   routes,
// });
